import './App.css';
import Jarvis from "./Components/JarvisUI"

function App() {
  return (
   <Jarvis/>
  );
}

export default App;
